// src/pages/SubscribePage.tsx
import { Helmet } from 'react-helmet-async';
import { NewsletterForm } from '../components/NewsletterForm';

export function SubscribePage() {
  return (
    <div className="min-h-screen bg-gray-950 text-yellow-100 flex flex-col items-center justify-center px-6 py-16">
      <Helmet>
        <title>Subscribe to PropViper Newsletter</title>
        <meta
          name="description"
          content="Get smart trading tips, prop firm reviews, and exclusive promo codes delivered to your inbox. Join free."
        />
      </Helmet>

      <div className="max-w-xl w-full text-center space-y-6">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-yellow-400">
          Get Smarter About Prop Trading
        </h1>

        <p className="text-lg text-yellow-200">
          Join 1000+ traders getting exclusive tips, guides, and prop firm discounts direct to their inbox.
        </p>

        <div className="pt-6">
          <NewsletterForm source="subscribe_page" />
        </div>

        <p className="text-sm text-gray-400 pt-4">
          No spam. Unsubscribe anytime.
        </p>
      </div>
    </div>
  );
}
